var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-course-subject" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 18 } }, [
            _c("div", { staticClass: "course-box" }, [
              _c("div", { staticClass: "box filter-box" }, [
                _c("ul", { staticClass: "filter-list" }, [
                  _c("li", { staticClass: "item" }, [
                    _c("span", { staticClass: "tit" }, [_vm._v("课程类型")]),
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      _vm._l(_vm.specialtyCount, function (item, index) {
                        return _c(
                          "el-radio",
                          {
                            key: index,
                            staticClass: "radio",
                            attrs: { label: item.course_type },
                            on: { change: _vm.typeChange },
                            model: {
                              value: _vm.courseType,
                              callback: function ($$v) {
                                _vm.courseType = $$v
                              },
                              expression: "courseType",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.title) +
                                " (" +
                                _vm._s(item.num) +
                                ") "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("span", { staticClass: "tit" }, [_vm._v("学习进度")]),
                    _c(
                      "div",
                      _vm._l(_vm.progressMap, function (item, index) {
                        return _c(
                          "el-radio",
                          {
                            key: index,
                            staticClass: "radio",
                            attrs: { label: item.type },
                            on: { change: _vm.typeChange },
                            model: {
                              value: _vm.progress,
                              callback: function ($$v) {
                                _vm.progress = $$v
                              },
                              expression: "progress",
                            },
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      }),
                      1
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "box content-box" },
                [
                  _c(
                    "div",
                    { staticClass: "titleDiv" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 2 } }, [
                            _c("p", [_vm._v("学期")]),
                          ]),
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("p", [_vm._v("课程名称")]),
                          ]),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _c("p", [_vm._v("学分")]),
                          ]),
                          _c("el-col", { attrs: { span: 5 } }, [
                            _c("p", [_vm._v("学习进度")]),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("p", [_vm._v("操作")]),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c(
                              "p",
                              { staticStyle: { "border-style": "none" } },
                              [_vm._v("状态")]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "ul",
                    { staticClass: "course-list" },
                    [
                      _c(
                        "el-row",
                        _vm._l(_vm.specialtyDtos, function (item) {
                          return _c(
                            "li",
                            { key: item.id, staticClass: "item" },
                            [
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("p", { staticClass: "p" }, [
                                  _vm._v(" " + _vm._s(item.semester) + " "),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "itemTitle" }, [
                                  _c("p", { staticClass: "tit" }, [
                                    _vm._v(_vm._s(item.title)),
                                  ]),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("p", { staticClass: "p" }, [
                                  _c("span", { staticClass: "num" }, [
                                    _vm._v(_vm._s(item.credit)),
                                  ]),
                                  _vm._v("学分 "),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c(
                                  "div",
                                  { staticClass: "p" },
                                  [
                                    _c("el-progress", {
                                      staticClass: "progress",
                                      attrs: { percentage: item.percentage },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                item.is_start == 1 && item.act_status == 1
                                  ? _c("div", { staticClass: "itemButton" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.goRouter(
                                                "subject",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("em", {
                                            staticClass: "iconfont iconshipin",
                                          }),
                                          _c("span", [_vm._v("去学习")]),
                                        ]
                                      ),
                                      item.student_type == 1
                                        ? _c("div", [
                                            item.course_type == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goRouterZy(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "iconfont iconicon f14",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("做作业"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.course_type === 2
                                              ? _c(
                                                  "button",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goRouterLx(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "iconfont iconjilu1 f14",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("去练习"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                      item.student_type == 2
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goRouterLx(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c("em", {
                                                  staticClass:
                                                    "iconfont iconjilu1 f14",
                                                }),
                                                _c("span", [_vm._v("去练习")]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _c("div", { staticClass: "itemButton" }, [
                                      _vm._v("未开放"),
                                    ]),
                              ]),
                              _c("el-col", { attrs: { span: 3 } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "p",
                                    style: _vm._f("paperColor")(item.rate_type),
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.progressMap[item.rate_type].title
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm.specialtyDtos.length == 0
                    ? _c("ComponentEmpty", {
                        attrs: { title: "暂无课程", tips: "" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _vm.studentMajor
              ? _c("div", { staticClass: "side-box" }, [
                  _c("div", { staticClass: "box info-box" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.studentMajor.professionName)),
                    ]),
                    _c("div", { staticClass: "mat40 text-center" }, [
                      _c("img", {
                        staticStyle: { width: "60%" },
                        attrs: {
                          src: require("@/assets/images/undraw_Upvote_re_qn2k.png"),
                          alt: "",
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "banner-box" }, [
                      _c("h3", { staticClass: "h3" }, [_vm._v("专业学习说明")]),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.studentMajor.profession_content
                          ),
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }